import * as React from 'react'
import { useEditGroups } from '@/modules/drivers/context/EditGroupsContext'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { FaIcon, faPenSolid } from '@/lib/fa'
import useGroupService from '@/modules/drivers/services/GroupService'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const EditGroupFooter = ({ close, remove,setIsOpenChangeGroupName, isDefaultGroup = false, }) => {
  const { t } = useLocalize()
  const { selectedGroup, confirmEditGroupMembers, loading } = useEditGroups()
  const { refresh, driversIds } = useDrivers()
  const { changeGroupName } = useGroupService()
  return (
    <div className="tw-flex tw-items-stretch tw-justify-between tw-border-t tw-border-base-300">
      <div className="tw-m-4 tw-flex tw-flex-col tw-items-start tw-gap-4">
        <div className="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-text-content-base/80">
          <p>{t('common.selected')}</p>
          <strong>
            {selectedGroup?.length || 0} / {driversIds.length}
          </strong>
          <p>{t('driverModule.drivers-count')}</p>
        </div>
        {!isDefaultGroup && (
          <div className="tw-flex tw-items-center tw-gap-2">
            {/* @TODO add group onclick function */}
            {/* <div className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-bg-secondary tw-p-3 hover:tw-opacity-70">
              <FaIcon icon={faPenSolid} className="tw-text-primary" />
              <button
               disabled={loading}
                onClick={async () => {
                  ;(await confirmEditGroupMembers(), refresh(), close())
                }}
                type="submit"
                className={`tw-text-sm tw-font-medium tw-text-primary`}
              >
                Zmień nazwę grupy
              </button>
            </div> */}
            <div className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-bg-red-500 tw-p-3 hover:tw-opacity-70">
              <FaIcon icon={faPenSolid} className="tw-text-white" />
              <button
                disabled={loading}
                onClick={async () => {
                  ;(await remove(), refresh(), close())
                }}
                type="submit"
                className={`tw-text-sm tw-font-medium tw-text-white`}
              >
                {t('common.delete')}
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="tw-flex tw-items-end tw-justify-end">
        <button
          disabled={loading}
          onClick={() => setIsOpenChangeGroupName(true)}
          type="submit"
          className={`tw-m-4 tw-mr-2 tw-ml-0 tw-cursor-pointer tw-rounded-lg tw-bg-secondary tw-p-3 tw-text-sm tw-font-medium tw-text-primary hover:tw-opacity-70`}
        >
          {t('driverModule.change-group-name')}
        </button>
        <button
          disabled={loading}
          onClick={async () => {
            ;(await confirmEditGroupMembers(), refresh(), close())
          }}
          type="submit"
          className={`tw-m-4 tw-ml-0 tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-70`}
        >
          {t('common.confirm')}
        </button>
      </div>
    </div>
  )
}

export default EditGroupFooter
